/* One cart path: this bar forwards to the existing product form, never posts its own. */
(() => {
  if (customElements.get('ark-sticky-atc')) return;
  class ArkStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) { document.body.append(this); return; }
      if (this.bound) return;
      this.form = document.getElementById(this.dataset.form);
      this.mainButton = this.form?.querySelector('button[name="add"]');
      this.button = this.querySelector('[data-sticky-submit]');
      this.summary = this.querySelector('[data-sticky-summary]');
      this.mode = this.querySelector('[data-sticky-mode]');
      this.change = this.querySelector('[data-sticky-change]');
      if (!this.mainButton || !this.button) return;
      this.bound = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.button.addEventListener('click', () => {
        this.sync();
        if (this.button.disabled || !this.mainButton.isConnected) return;
        // Main form retains selling_plan, variant, quantity, custom properties,
        // recipient validation, incomplete-kit guards and single-flight loading.
        this.mainButton.click();
        this.sync();
      }, {signal});
      this.change.addEventListener('click', () => {
        const target = this.form.closest('neurofuel-test-builder') || this.form.closest('.main-product__content') || this.form;
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
        const focus = target.querySelector('[data-nf-tier], input:not([type="hidden"]):not([disabled]), select:not([disabled]), button:not([disabled])');
        focus?.focus({preventScroll:true});
      }, {signal});
      const section = this.form.closest('.product-section') || this.form;
      section.addEventListener('change', this.schedule, {signal});
      section.addEventListener('input', this.schedule, {signal});
      this.form.addEventListener('variant:change', this.schedule, {signal});
      document.addEventListener('shopify:section:unload', event => {
        if (event.detail?.sectionId === section.dataset.sectionId) this.remove();
      }, {signal});
      window.addEventListener('scroll', this.schedule, {signal,passive:true});
      window.addEventListener('resize', this.schedule, {signal,passive:true});
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.form, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled','aria-disabled','value']});
      this.intersection = new IntersectionObserver(this.schedule);
      this.intersection.observe(this.mainButton);
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.mainButton);
      this.sync();
    }
    sync() {
      if (!this.bound) return;
      const label = (this.mainButton.querySelector('.button-label')?.textContent || this.mainButton.textContent).replace(/\s+/g,' ').trim();
      if (this.summary.textContent !== label) this.summary.textContent = label;
      if (this.button.getAttribute('aria-label') !== label) this.button.setAttribute('aria-label',label);
      const busy = this.mainButton.classList.contains('loading') || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = this.mainButton.disabled || busy || !this.mainButton.isConnected;
      this.button.classList.toggle('loading',busy);
      this.button.setAttribute('aria-busy',String(busy));
      const formData = new FormData(this.form);
      const plan = formData.get('selling_plan');
      const builder = this.form.closest('neurofuel-test-builder');
      const subscriptionSelected = builder
        ? builder.querySelector('[data-nf-purchase="subscription"]')?.getAttribute('aria-pressed') === 'true'
        : !!plan;
      const mode = subscriptionSelected ? this.dataset.subscription : this.dataset.once;
      if (this.mode.textContent !== mode) this.mode.textContent = mode;
      // Hide before/alongside the main CTA; appear only after scrolling past it.
      const visible = this.mainButton.isConnected && this.mainButton.getBoundingClientRect().bottom < 0;
      this.classList.toggle('visible',visible);
      this.setAttribute('aria-hidden',String(!visible));
      this.inert = !visible;
    }
    disconnectedCallback() {
      this.abort?.abort();this.observer?.disconnect();this.intersection?.disconnect();this.resize?.disconnect();
      if(this.frame)cancelAnimationFrame(this.frame);
      this.frame=0;this.bound=false;
    }
  }
  customElements.define('ark-sticky-atc',ArkStickyAtc);
})();
